const filterFields = {
  offer: 'offer',
  platform: 'platform',
  channel: 'channel',
  utm: 'utm',
};
export default filterFields;
